<template>
  <v-layout column>
    <v-flex align-self-end class="tw-flex tw-gap-2 tw-justify-end">
      <AddUser v-on:complete="refresh" v-if="checkScope(scopeLiterals.UsersCreate)" />
    </v-flex>
    <v-flex xs12>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="invites"
        :pagination.sync="pagination"
        select-all
        item-key="id"
        :loading="isLoading ? 'accent' : false"
        class="tw-border tw-border-neutral-100 tw-rounded-lg tw-overflow-hidden tw-mt-3"
      >
        <v-progress-linear slot="progress" color="accent" height="2" indeterminate></v-progress-linear>
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable text-xs-' + header.align,
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td>{{ props.item.userName }}</td>
            <td>{{ props.item.email }}</td>
            <!-- <td class="text-xs-right">
              <v-btn icon @click.stop="">
                <v-icon>close</v-icon>
              </v-btn>
            </td> -->
            <td class="text-xs-right">
              <button
                type="button"
                class="tw-rounded-full tw-text-red-400 hover:tw-text-red-500 disabled:tw-text-gray-300"
                @click="cancelInvitation(props.item.id)"
                v-if="checkScope(scopeLiterals.UsersDelete)"
                v-on:completed="refresh"
              >
                <fa icon="fa-regular fa-circle-xmark" class="tw-text-2xl" />
              </button>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import gql from 'graphql-tag';

import AddUser from './AddUser';
import RevokeUser from './RevokeUser';

export default {
  props: [],
  components: {
    AddUser: AddUser,
  },
  data() {
    return {
      invites: [],
      selected: [],
      isLoading: 0,
      pagination: {
        sortBy: 'email',
      },
      headers: [
        {
          text: 'name',
          align: 'left',
          value: 'userName',
        },
        {
          text: 'email',
          align: 'left',
          value: 'email',
        },
      ],
    };
  },
  apollo: {
    invites: {
      // pollInterval: 5000,
      query: gql`
        query GetOrgInvites($id: ID!) {
          org(id: $id) {
            id
            invites {
              id
              userName
              email
              byUserId
            }
          }
        }
      `,
      update(data) {
        return data.org.invites ? data.org.invites : [];
      },
      variables() {
        // Use vue reactive properties here
        return {
          id: this.$store.state.currentOrg.id,
        };
      },
      loadingKey: 'isLoading',
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$apollo.queries.invites.refetch();
    },
    async cancelInvitation(inviteId) {
      try {
        this.isSaving = true;
        const vars = {
          inviteId: inviteId,
        };
        const resp = await this.$apollo.mutate({
          // Query
          mutation: gql`
            mutation ($inviteId: ID!) {
              declineInvitation(inviteId: $inviteId)
            }
          `,
          // Parameters
          variables: vars,
        });
        if (!resp.errors) {
          this.showSuccessSnackbar('Invitation Cancelled');
          console.log(resp.data);
        } else {
          this.showErrorSnackbar('Error cancelling invitation');
        }

        this.refresh();
      } catch (error) {
        console.error(error);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
